import { ManualCodeEntry } from '@/components/manual-code-entry/component';
import { Scanner } from '@/components/scanner';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { Box, Button, Flex } from '@mantine/core';
import { useState } from 'react';
import { useBagScanContext } from '../hook';

export const BagScanScanPage = () => {
	const { handleScan, setPage, showCodeEntry, setShowCodeEntry } = useBagScanContext();
	const [code, setCode] = useState('');

	return (
		<Box>
			<MobileHeader title="Scan a Bag" onBack={() => setPage('INSTRUCTIONS')} />
			<Scanner onScan={handleScan} />

			<ManualCodeEntry
				value={code}
				setValue={setCode}
				open={showCodeEntry}
				instructions="Please enter the code found on your Curby bag."
				onClose={() => {
					setCode('');
					setShowCodeEntry(false);
				}}
				shouldValidate
				actions={({ isValid, onClose }) => {
					return (
						<Flex w="100%" gap="sm">
							<Button fullWidth variant="filled" bg="grey" c="white" onClick={onClose}>
								Close
							</Button>
							<Button
								fullWidth
								disabled={!isValid}
								variant="filled"
								onClick={() => handleScan(code)}
							>
								Submit
							</Button>
						</Flex>
					);
				}}
			/>
		</Box>
	);
};
